<template lang="pug">
v-container.px-10(fluid)
  v-row(justify-end)
    v-col
      v-text-field(
        :label="`${$t('Trigger.name')} *`",
        v-model="instance.name",
        :error-messages="errors['trigger.name']",
      )
    v-col
      v-text-field(
        :label="$t('Trigger.description')",
        v-model="instance.description",
      )
  v-row(justify-end)
    v-col
      v-select(
        v-model="instance.on",
        :label="`${$t('Trigger.on')} *`",
        :items="eventTypes",
        :error-messages="errors['trigger.on']",
      )
    v-col
      v-select(
        :label="`${$t('Trigger.entity')} *`",
        v-model="instance.entity",
        :items="$store.state.schema.all",
        item-text="name",
        item-value="name",
        :error-messages="errors['trigger.entity']",
      )
    v-col
      v-text-field(
        :label="$t('Trigger.sequence')",
        v-model="instance.sequence",
        type="number"
      )
</template>

<script>
import EntityMixin from "@/mixins";

export default {
  mixins: [EntityMixin],
  name: "Trigger",
  props: ["path", "entity"],
  data: () => ({
    eventTypes: ["ADDED", "MODIFIED", "DELETED", "SCHEDULED"],
  }),
  watch: {
    selectedEntity: {
      immediate: true,
      handler(value) {
        this.$store.commit("SET_CRITERIA_ENTITY_NAME", value);
      },
    }
  },
  computed: {
    selectedEntity() {
      return this.instance.entity;
    },
    errors() {
      return this.$store.state.errors;
    }
  }
};
</script>
